import styled, { css } from 'styled-components';
import { theme } from '../../constants/theme.mjs';
"use strict";
const InnerWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  position: relative;
`;
const LoaderDotsWrap = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
const StyledButton = styled.button`
  /* Possible padding should be handled by the size attribute not shared for both buttons */
  padding: 6px 16px;
  cursor: pointer;

  /* Button font gets reset by the browser, inherit it */
  font-family: inherit;

  ${({
  disabled,
  $loading
}) => disabled || $loading ? css`
          cursor: not-allowed;
        ` : css`
          &&:active {
            opacity: 0.9;
          }
        `}

  ${({
  variant,
  disabled,
  $loading
}) => {
  switch (variant) {
    case "primary":
      return css`
          background: ${theme.colors.primaryBlue};
          color: ${theme.colors.white};
          border: 1px solid ${theme.colors.primaryBlue};
          transition: background 0.3s;

          ${!$loading && css`
            &&:hover {
              color: ${theme.colors.white};
              border-color: ${theme.colors.dodgerblue};
              background-color: ${theme.colors.dodgerblue};
            }
          `}

          ${disabled && !$loading && css`
            background: ${theme.colors.anakiwa};
            border: 1px solid ${theme.colors.anakiwa};

            &&:hover {
              border-color: ${theme.colors.anakiwa};
              background-color: ${theme.colors.anakiwa};
            }
          `}
        `;
    case "secondary":
      return css`
          background: transparent;
          color: ${theme.colors.primaryBlue};
          border: 1px solid ${theme.colors.primaryBlue};
          padding: 4px 16px;

          ${!$loading && css`
            &&:hover {
              color: ${theme.colors.cornFlower};
              border-color: ${theme.colors.cornFlower};
              background-color: ${theme.colors.cornFlower20};
            }
          `}

          ${disabled && !$loading && css`
            background: transparent;
            color: ${theme.colors.cornFlower20};
            border: 1px solid ${theme.colors.cornFlower20};

            &&:hover {
              background: transparent;
              color: ${theme.colors.cornFlower20};
              border: 1px solid ${theme.colors.cornFlower20};
            }
          `}
        `;
    case "link":
      return css`
          color: ${theme.colors.primaryBlue};
          background: none;
          border: none;
          transition: color 0.3s;
          padding: 0;

          ${!$loading && css`
            /* Check for hover capability to prevent wrong UI styles of category tabs https://developer.mozilla.org/en-US/docs/Web/CSS/@media/hover */
            @media (hover: hover) {
              &&:hover {
                color: ${theme.colors.dodgerblue};
              }
            }
          `}

          ${disabled && !$loading && css`
            color: ${theme.colors.anakiwa};

            &&:hover {
              color: ${theme.colors.anakiwa};
            }
          `}
        `;
    case "cancel":
      return css`
          color: ${theme.colors.black65};
          background: none;
          border: 1px solid transparent;

          ${!$loading && css`
            &&:hover {
              color: ${theme.colors.black65};
              background-color: ${theme.colors.athensGreyLight};
              border: 1px solid ${theme.colors.athensGreyLight};
            }
          `}

          ${disabled && !$loading && css`
            color: ${theme.colors.black20};
          `}
        `;
    case "tertiary":
      return css`
          color: ${theme.colors.black65};
          background: none;
          border: none;

          ${!$loading && css`
            &&:hover {
              border-color: ${theme.colors.athensGreyLight};
              background-color: ${theme.colors.athensGreyLight};
            }
          `}
        `;
    case "delete":
      return css`
          background: ${theme.colors.pomegranate};
          color: ${theme.colors.white};
          border: 1px solid ${theme.colors.pomegranate};
          transition: background 0.3s;

          ${!$loading && css`
            &&:hover {
              color: ${theme.colors.white};
              border-color: ${theme.colors.sunsetOrange};
              background-color: ${theme.colors.sunsetOrange};
            }
          `}
        `;
    case "unavailable":
      return css`
          background: #eee;
          color: #8e8e8e;
          border: 1px solid #eee;
          font-weight: 700 !important;
        `;
    case "comingSoon":
      return css`
          background: #e0e4f1;
          color: #445178;
          border: 1px solid #e0e4f1;
          font-weight: 700 !important;
        `;
    case "gray":
      return css`
          background: ${theme.colors.athensGreyLight};
          color: ${theme.colors.black65};
          border: 1px solid ${theme.colors.athensGreyLight};

          ${!$loading && css`
            &&:hover {
              border-color: ${theme.colors.athensGreyDark};
              background-color: ${theme.colors.athensGreyDark};
            }
          `}
        `;
    default:
      return null;
  }
}}

  ${({
  size,
  bold
}) => {
  switch (size) {
    case "large":
      return css`
          font-size: ${theme.font.size16};
          line-height: ${theme.lineHeight.subHeader};
          /* For large size will be bold unless bold explicitly set to false */
          font-weight: ${bold === false ? "normal" : "bold"};
          border-radius: 8px;

          /* Disabled as padding should set it's size, if no complaints after 15.jul 2022, we can remove it */
          /* min-height: 48px; */
        `;
    default:
      return css`
          font-size: ${theme.font.size14};
          line-height: ${theme.lineHeight.subHeader};
          font-weight: ${bold ? "bold" : "normal"};
          border-radius: 4px;

          /* Disabled as padding should set it's size, if no complaints after 15.jul 2022, we can remove it */
          /* min-height: 34px; */
        `;
  }
}}

  ${({
  full
}) => full && css`
      width: 100%;
    `}

  ${({
  $loading
}) => $loading && css`
      color: transparent;
    `}
`;
export { InnerWrap, LoaderDotsWrap, StyledButton };
//# sourceMappingURL=Button.styles.mjs.map
